import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  Products_Relocations_DiscontinueProductType,
  RequestDataDC_Products_Client_Old_Client_Models_OfferMailRequestModel,
  RequestDataDC_Products_Client_Old_Client_Models_SendOfferUsagesRequestModel,
  RequestModels_Products_Leads_BusinessLeadRequestModel,
  RequestModels_Products_Leads_CommercialOpportunityRequestModel,
  RequestModels_Products_Offers_OfferEventRequestModel,
  RequestModels_Products_Offers_OfferProductsPublicRequest,
  RequestModels_Products_Offers_V3_OfferProductsPublicV3Request,
  RequestModels_Products_Order_ProductOrder,
  ResponseDataDC_Products_Client_Old_Client_Models_DiscontinueReasons,
  ResponseDataSystem_String,
  ResponseModels_Products_Interruption_InterruptionModel,
  ResponseModels_Products_Offers_PublicOffer,
  ResponseModels_Products_Offers_V3_OfferResponseModel,
  ResponseModels_Products_Orders_CreateOrderResponseLocal,
  ResponseModels_Products_ProductCombinationResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetOfferProducts = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Products_Offers_OfferProductsPublicRequest;
};
/**
 * Get OfferProducts public
 *
 * @returns ResponseModels_Products_Offers_PublicOffer Success
 */
export function getOfferProducts(
  { businessUnit, label, requestBody }: GetOfferProducts,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Products_Offers_PublicOffer> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/products/offerproducts`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetOfferProductsV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Products_Offers_V3_OfferProductsPublicV3Request;
};
/**
 * Get OfferProducts public
 *
 * @returns ResponseModels_Products_Offers_V3_OfferResponseModel Success
 */
export function getOfferProductsV3(
  { businessUnit, label, requestBody }: GetOfferProductsV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Products_Offers_V3_OfferResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/v3/${businessUnit}/${label}/products/offerproducts`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type GetProductTypeCombinations = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Products_Offers_OfferProductsPublicRequest;
};
/**
 * Get ProductType Combinations
 *
 * @returns ResponseModels_Products_ProductCombinationResponseModel Success
 */
export function getProductTypeCombinations(
  { businessUnit, label, requestBody }: GetProductTypeCombinations,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Products_ProductCombinationResponseModel> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/products/producttypecombinations`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type PutProductsOrder = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Products_Order_ProductOrder;
};
/**
 * Places an order to the CRM Campaign Interface.
 *
 * @returns ResponseDataSystem_String The order has been placed for queue and is being processed
 */
export function putProductsOrder(
  { businessUnit, label, requestBody }: PutProductsOrder,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataSystem_String> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/${businessUnit}/${label}/products/orders`,
      body: requestBody,
      errors: { 400: 'Means that the back-end or any related services had an error' },
    },
    requestConfig,
  );
}

type PutProductsOrderV2 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Products_Order_ProductOrder;
};
/**
 * Places an order to the CRM Campaign Interface.
 *
 * @returns ResponseModels_Products_Orders_CreateOrderResponseLocal The order has been placed for queue and is being processed
 */
export function putProductsOrderV2(
  { businessUnit, label, requestBody }: PutProductsOrderV2,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Products_Orders_CreateOrderResponseLocal> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/v2/${businessUnit}/${label}/products/orders`,
      body: requestBody,
      errors: { 400: 'Means that the back-end or any related services had an error' },
    },
    requestConfig,
  );
}

type SubmitBusinessLead = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Products_Leads_BusinessLeadRequestModel;
  recaptchaEnterpriseToken?: string;
};
/**
 * Submits a business lead.
 *
 * @returns any Success
 */
export function submitBusinessLead(
  { businessUnit, label, requestBody, recaptchaEnterpriseToken }: SubmitBusinessLead,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/${businessUnit}/${label}/products/businessleads`,
      body: requestBody,
      headers: { recaptchaEnterpriseToken },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type SubmitCommercialOpportunity = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody: RequestModels_Products_Leads_CommercialOpportunityRequestModel;
};
/**
 * Submit commercial business opportunity quoation
 *
 * @returns any Success
 */
export function submitCommercialOpportunity(
  { businessUnit, label, requestBody }: SubmitCommercialOpportunity,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/${businessUnit}/${label}/products/commercialopportunity`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetInterruptions = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  startDate?: string;
  endDate?: string;
};
/**
 * Get all the current known interruptions on the Eneco Network
 *
 * @returns ResponseModels_Products_Interruption_InterruptionModel Success
 */
export function getInterruptions(
  { businessUnit, label, startDate, endDate }: GetInterruptions,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Products_Interruption_InterruptionModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/products/interruptions`,
      query: { startDate, endDate },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetDiscontinueReasons = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  productType: Products_Relocations_DiscontinueProductType;
};
/**
 * Get all discontinue reasons
 *
 * @returns ResponseDataDC_Products_Client_Old_Client_Models_DiscontinueReasons Success
 */
export function getDiscontinueReasons(
  { businessUnit, label, productType }: GetDiscontinueReasons,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataDC_Products_Client_Old_Client_Models_DiscontinueReasons> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/products/${productType}/discontinue`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type SendOfferUsagesFeatures = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody?: RequestDataDC_Products_Client_Old_Client_Models_SendOfferUsagesRequestModel;
};
/**
 * Send offer usages features to feature topic
 *
 * @returns void
 */
export function sendOfferUsagesFeatures(
  { businessUnit, label, requestBody }: SendOfferUsagesFeatures,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/products/sendofferusages`,
      body: requestBody,
    },
    requestConfig,
  );
}

type SendOfferByMail = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody?: RequestDataDC_Products_Client_Old_Client_Models_OfferMailRequestModel;
};
/**
 * Sends the offer in the shopping basket to the customer by mail so that they can look at it later (for B2B)
 *
 * @returns void
 */
export function sendOfferByMail(
  { businessUnit, label, requestBody }: SendOfferByMail,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/offers/mail`,
      body: requestBody,
    },
    requestConfig,
  );
}

type RecordOfferEvent = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody?: RequestModels_Products_Offers_OfferEventRequestModel;
};
/**
 * Receives offer view events (which customers saw which offers).
 *
 * @returns void
 */
export function recordOfferEvent(
  { businessUnit, label, requestBody }: RecordOfferEvent,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/public/${businessUnit}/${label}/offers/events`,
      body: requestBody,
    },
    requestConfig,
  );
}
